import { ModalBaseProps } from '@mantine/core';
import { ReactNode, useState } from 'react';
import { queryParams } from 'utils/query';
import { modals, openConfirmModal } from '@mantine/modals';
import { useParameters } from './useParameters';

export type OpenConfirmModal = Parameters<typeof openConfirmModal>[0];
export interface DrawerOptions {
  content: ReactNode;
  size?: ModalBaseProps['size'];
  lockScroll?: boolean;
  title?: string | ReactNode;
  actions?: ReactNode;
  detailId?: string;
}

export interface CloseDrawerOptions {
  showDiscardModal: boolean;
}

export const useGeneralDrawer = () => {
  const [isDrawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [size, setSize] = useState<ModalBaseProps['size']>();
  const [content, setContent] = useState<ReactNode>();
  const [lockScroll, setLockScroll] = useState(true);
  const [title, setTitle] = useState<string | ReactNode>();
  const [actions, setActions] = useState<ReactNode>();
  const { setParameters, parameters: filters } = useParameters();
  const [discardModal, setDiscardModal] = useState<OpenConfirmModal>();

  const openDrawer = (options: DrawerOptions) => {
    setContent(options.content);
    setSize(options?.size || 'xl');
    setLockScroll(options?.lockScroll || true);
    setTitle(options.title);
    setActions(options.actions);
    setDrawerOpen(true);
    if (options.detailId) {
      setParameters({ ...filters, [queryParams.detailId]: options.detailId });
    }
  };

  const onClose = () => {
    setParameters({ ...filters, [queryParams.detailId]: '' });
    setDrawerOpen(false);
    setDiscardModal(undefined);
  };

  const closeDrawer = (showDiscardModal = true) => {
    if (showDiscardModal && discardModal) {
      modals.openConfirmModal({ ...discardModal, onConfirm: onClose });
      return;
    }
    onClose();
  };

  return {
    isDrawerOpen,
    closeDrawer,
    openDrawer,
    size,
    content,
    lockScroll,
    title,
    actions,
    setDiscardModal,
  };
};
